import * as React from 'react';
import { useState, useRef, useCallback, useEffect } from 'react';

/** Material UI Packages. */
import { Fab, Tooltip } from '@mui/material';

/** Material UI Icons. */
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

/** Internal Components. */
import TodoPanel from './TodoPanel';

export default function TodoFab(props) {
    /** Get props from Shipments.js. */
    const { reminderList, setReminderList } = props;
    /** State for managing a drawer active for todo panel. */
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    /** State for managing the position of the FAB. */
    const [fabPosition, setFabPosition] = useState({ bottom: 45, right: 16 });
    /** State for managing the dragging of the FAB. */
    const isDragging = useRef(false);
    /** State for managing the offset of the FAB. */
    const dragOffset = useRef({ x: 0, y: 0 });

    /** Handle to open a drawer. */
    const handleFabClick = () => {
        setIsDrawerOpen(true);
    };

    const handleMouseDown = (e) => {
        isDragging.current = true;
        dragOffset.current = {
            x: e.clientX + fabPosition.right,
            y: e.clientY + fabPosition.bottom, // window.innerHeight - e.clientY - fabPosition.bottom 으로 조정 필요
        };
        e.preventDefault();
    };

    const handleMouseMove = useCallback((e) => {
        if (!isDragging.current) return;
        setFabPosition({
            right: Math.max(0, dragOffset.current.x - e.clientX),
            bottom: Math.max(0, window.innerHeight - e.clientY - 20),
        });
    }, []);

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [handleMouseMove]);

    return (
        <>
            <Fab
                size="small"
                color="primary"
                sx={{
                    position: 'fixed', // absolute → fixed 권장
                    bottom: fabPosition.bottom,
                    right: fabPosition.right,
                    cursor: isDragging.current ? 'grabbing' : 'grab',
                }}
                onMouseDown={handleMouseDown}
                onClick={handleFabClick}
            >
                <Tooltip title="TODO" arrow>
                    <EventAvailableIcon />
                </Tooltip>
            </Fab>

            <TodoPanel
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                reminderList={reminderList}
                setReminderList={setReminderList}
            />
        </>
    );
}
